module.exports = __webpack_public_path__ + "static/media/summary.989562c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/summary.png
// module id = 70
// module chunks = 0